import type {
  ContractPartiesQueryParams,
  ContractPartiesResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodContractPartiesQueryParamsSchema,
  zodContractPartiesResponseSchema,
} from './validations';

/**
 * Fetches the distinct companies that appear as buyer or seller on contracts
 * the caller can see, for the contract list party filters.
 *
 * @param queryParams - The query parameters for fetching contract parties.
 * @param options - Additional options for the request (e.g., abort signal).
 * @returns The paginated contract party filter options.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/get_contract_party_filter_options_contracts_filter_options_parties_get
 */
export const fetchContractParties = async (
  queryParams: Partial<ContractPartiesQueryParams>,
  options?: KyRequestOptions,
) => {
  return await vestigasApi
    .get(ENDPOINT.CONTRACT.GET_FILTER_PARTIES(), {
      searchParams: queryParams as Record<
        string,
        string | number | boolean | undefined
      >,
      ...options,
      validate: {
        ...options?.validate,
        response: zodContractPartiesResponseSchema,
        searchParams: zodContractPartiesQueryParamsSchema.transform((data) =>
          withoutObjectKeysWhereValueIs(data, [undefined, '']),
        ),
      },
    })
    .json<ContractPartiesResponse>();
};
